<span class="badge badge-pessoa-tipo badge-pessoa-tipo-central-compras" [title]="config?.titleHint">
    {{tipo.nome}}
    <span *ngIf="quantidadeParticipantes > 0">
        ({{quantidadeParticipantes | decimalFormat: 1:0:0}})
    </span>
</span>